import { reportsRequest } from "./reportsRequest";

export default reportsRequest;
